<template>
  <div v-if="hasAccessToPage">
    <v-app-bar elevation="1" color="lightPrimary" class="light-grey-border-bottom">
      <v-container fluid class="align-center">
        <v-row justify="start" class="mx-4">
          <v-col class="d-flex" cols="12" lg="12" xl="11">
            <LabLocationSelector />
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>

    <v-container fluid class="hoh-entry-form-entries-page">
      <!-- title -->
      <v-row justify="start" class="mb-4 mt-0 mx-4" v-if="selectedDate">
        <v-col cols="12" sm="12" md="12" lg="12" xl="11">
          <div class="d-flex align-center">
            <div style="flex: 1">
              <v-btn @click="$router.push({ name: 'AppointmentsCalendarPage' })" class="me-2" small elevation="0" color="primary" outlined>
                <v-icon left>mdi-arrow-left</v-icon>
                Back to Calendar
              </v-btn>
            </div>
            <div class="text-center title">
              <v-btn fab @click="goToDay(-1)" class="me-4" small elevation="0" color="grey lighten-2">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <v-icon large color="grey darken-3">mdi-calendar</v-icon>
              <template v-if="selectedDate">{{ formatDate(selectedDate) }}</template>
              <v-btn fab @click="goToDay(1)" class="ms-4" small elevation="0" color="grey lighten-2">
                <v-icon>mdi-arrow-right</v-icon>
              </v-btn>
            </div>
            <div style="flex: 1"></div>
          </div>
          <v-divider class="mt-2"></v-divider>
        </v-col>
      </v-row>
      <v-row justify="start" class="mx-4">
        <!-- appointments table -->
        <v-col cols="12" sm="12" md="7" lg="7" xl="7" offset-xl="0">
          <AppointmentsTable />
        </v-col>
        <!-- appointments table -->
        <v-col cols="12" sm="12" md="5" lg="5" xl="4">
          <TimeSlotsTable :selectedDate="selectedDate" />
        </v-col>
      </v-row>

      <!-- Modals -->
      <AppointmentModalForm />
      <ConfirmDeleteModal />
      <RescheduleAppointmentModal v-if="$store.state.appointmentsCalendarStore.appointmentsSelectedDayPage.rescheduleAppointmentDialog" />
    </v-container>
  </div>
  <no-access-message v-else />
</template>

<script>
import moment from 'moment';
import SharedFunctions from '@/mixins/SharedFunctions.vue';

import AppointmentsTable from '@/views/AppointmentsCalendarPage/AppointmentsSelectedDayPage/components/appointments-table.vue';
import TimeSlotsTable from '@/views/AppointmentsCalendarPage/AppointmentsSelectedDayPage/components/time-slots-table.vue';
import AppointmentModalForm from '@/views/AppointmentsCalendarPage/AppointmentsSelectedDayPage/components/appointment-modal-form.vue';
import ConfirmDeleteModal from '@/views/AppointmentsCalendarPage/AppointmentsSelectedDayPage/components/confirm-delete-modal.vue';
import RescheduleAppointmentModal from '@/views/AppointmentsCalendarPage/AppointmentsSelectedDayPage/components/reschedule-appointment-modal.vue';
import LabLocationSelector from '@/views/AppointmentsCalendarPage/components/lab-location-selector.vue';

export default {
  mixins: [SharedFunctions],
  components: {
    AppointmentsTable,
    TimeSlotsTable,
    AppointmentModalForm,
    ConfirmDeleteModal,
    RescheduleAppointmentModal,
    LabLocationSelector
  },
  data() {
    return {
      hasAccessToPage: false
    };
  },
  computed: {
    selectedDate() {
      return this.$route.params.selectedDate;
    }
  },
  created() {
    this.hasAccessToPage = this.hasAccessToPageMixin();
  },
  mounted() {},
  methods: {
    formatDate(d) {
      return moment(d, 'YYYY-MM-DD').format('DD-MMM-YYYY');
    },
    goToDay(dayToGoTo) {
      let day = moment(this.selectedDate, 'YYYY-MM-DD').add(dayToGoTo, 'days');
      this.$router.push({ name: 'AppointmentsSelectedDayPage', params: { selectedDate: day.format('YYYY-MM-DD') } });
    },
  }
};
</script>

<style lang="scss">
</style>